import React, { useState, useEffect } from "react";
import { AppBar, useScrollTrigger, Slide, Box } from "@mui/material";
import MainAppbar from "../../../../Components/Widgets/MainAppbar";
import CartPopper from "../../../../Components/Widgets/CartPopper";
import { useTheme } from "@mui/material/styles";

function HideOnScroll(props) {
  const { children, window, openMenu } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disabled: openMenu,
  });

  return (
    <Slide appear={false} direction="down" in={openMenu || !trigger}>
      {children ?? <div />}
    </Slide>
  );
}

export default function NavBar(props) {
  const [openMenu, setOpenMenu] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (!openMenu) return;

    const scrollY = window.scrollY;
    const pathnameWhenOpened = window.location.pathname;
    const { body, documentElement } = document;
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overflow = "hidden";

    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.overflow = "";
      body.style.paddingRight = "";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const navigatedAway =
            window.location.pathname !== pathnameWhenOpened;
          window.scrollTo(0, navigatedAway ? 0 : scrollY);
        });
      });
    };
  }, [openMenu]);

  return (
    <>
      <HideOnScroll {...props} openMenu={openMenu}>
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            background: "transparent",
          }}
          elevation={0}
        >
          <MainAppbar
            {...{
              ...props,
              openMenu,
              setOpenMenu,
            }}
          />
          <CartPopper
            {...{
              ...props,
              ...{},
            }}
          />
        </AppBar>
      </HideOnScroll>
      <Box
        sx={{
          height: {
            xs: theme.appbar_height.mobile,
            lg: theme.appbar_height.desktop,
          },
        }}
      />
      {openMenu && (
        <Box
          sx={{
            position: "fixed",
            left: 0,
            zIndex: 1000,
            width: "100%",
            height: "100%",
            backdropFilter: "blur(3px)",
          }}
        />
      )}
    </>
  );
}
